<template>
	<div class="position-relative">
		<div class="authentication-wrapper authentication-basic container-p-y p-4 p-sm-0">
			<div class="authentication-inner py-6">
				<!-- Register Card -->
				<div class="card p-md-7 p-1">
					<!-- Logo -->
					<div class="app-brand justify-content-center mt-5">
						<a href="javascript:void(0)" class="app-brand-link gap-2">
							<span class="app-brand-logo demo">
								<span style="color: var(--bs-primary)">
									<img :src="logoUrl" :style="logoSize()" alt="Logo">
								</span>
							</span>
						</a>
					</div>
					<!-- /Logo -->
					<div class="card-body mt-1">
						<p class="mb-5 text-center">Bienvenue chez {{ brandName }}</p>

						<form id="formAuthentication" @submit.prevent="registerUser" class="mb-5">
							<div class="form-floating form-floating-outline mb-5">
								<input
									type="text"
									class="form-control"
									id="firstName"
									name="firstName"
									placeholder="Votre prénom"
									v-model="form.firstName"
									@input="clearError('firstName')"
									autofocus />
								<label for="firstName">Prénom</label>
								<small v-if="errors.firstName" class="text-danger">{{ errors.firstName }}</small>
							</div>
							<div class="form-floating form-floating-outline mb-5">
								<input
									type="text"
									class="form-control"
									id="lastName"
									name="lastName"
									placeholder="Votre nom"
									v-model="form.lastName"
									@input="clearError('lastName')"
									autofocus />
								<label for="lastName">Nom</label>
								<small v-if="errors.lastName" class="text-danger">{{ errors.lastName }}</small>
							</div>
							<div class="form-floating form-floating-outline mb-5">
								<input 
									type="text"
									id="bs-datepicker-basic"
									placeholder="DD/MM/YYYY"
									class="form-control"
									ref="birthDate"
									@input="handleDateInput"
									v-model="form.birthDate"
								/>
								<label for="birthDate">Date de naissance</label>
								<small v-if="errors.birthDate" class="text-danger">{{ errors.birthDate }}</small>
							</div>
							<div class="form-floating form-floating-outline mb-5">
								<input type="text" class="form-control" id="email" name="email" placeholder="Enter your email" v-model="form.email" @input="clearError('email')" />
								<label for="email">Email</label>
								<small v-if="errors.email" class="text-danger">{{ errors.email }}</small>
							</div>
							<div class="mb-5 form-password-toggle">
								<div class="input-group input-group-merge">
									<div class="form-floating form-floating-outline">
										<input
											type="password"
											id="password"
											class="form-control"
											name="password"
											placeholder="&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;"
											aria-describedby="password" v-model="form.password" @input="clearError('password')" />
										<label for="password">Mot de passe</label>
									</div>
									<span class="input-group-text cursor-pointer"><i class="ri-eye-off-line"></i></span>
									<small v-if="errors.password" class="text-danger">{{ errors.password }}</small>
								</div>
							</div>
							<div class="form-floating form-floating-outline mb-5">
								<input
									type="text"
									class="form-control"
									id="companyName"
									name="companyName"
									placeholder="Votre société"
									v-model="form.companyName"
									@input="clearError('companyName')"
									autofocus />
								<label for="companyName">Nom de votre société</label>
								<small v-if="errors.companyName" class="text-danger">{{ errors.companyName }}</small>
							</div>

							<div class="mb-5">
								<div class="form-check mt-2">
									<input class="form-check-input" type="checkbox" id="terms-conditions" name="terms" v-model="form.terms" />
									<label class="form-check-label" for="terms-conditions">
										J'accepte les
										<a href="https://pika-aero.com/cgv" target="_blank">conditions d'utilisation</a>
									</label>
								</div>
								<small v-if="errors.terms" class="text-danger">{{ errors.terms }}</small>
							</div>
							<button class="btn btn-primary d-grid w-100">Créez votre compte</button>
						</form>

						<p class="text-center">
							<span>Vous avez déjà un compte ? </span>
							<router-link to="/login">
								<span>Connectez vous</span>
							</router-link>
						</p>
					</div>
				</div>
				<!-- Register Card -->
				<img
					alt="mask"
					src="@/assets/img/illustrations/auth-basic-register-mask-light.png"
					class="authentication-image d-none d-lg-block"
					data-app-light-img="illustrations/auth-basic-register-mask-light.png"
					data-app-dark-img="illustrations/auth-basic-register-mask-dark.png" />
			</div>
		</div>
	</div>
</template>

<script>
import { event } from "vue-gtag"
import "@/assets/vendor/css/pages/page-auth.css";

import HTTP from "@/axios";

export default {
	name: "RegisterPage",

	data() {
		return {
			domain: null,
			hideReferral: false,
			form: {
				firstName: "",
				lastName: "",
				email: "",
				password: "",
				companyName: "",
				birthDate: null,
				terms: false,
				referralCode: null
			},
			errors: {},
		};
	},

	async mounted() {
		this.domain = window.location.hostname;

		if (this.$route.query.r) {
			this.form.referralCode = this.$route.query.r;
		}

		if (this.domain === "2mtraining.pika-aero.com") {
			this.form.referralCode = "2MTraining";
		}
	},

	computed: {
		logoUrl() {
			if (this.domain === '2mtraining.pika-aero.com') {
				return require('@/assets/logo-2mtraining.png');
			} else {
				return require('@/assets/logo.png');
			}
		},

		brandName() {
			if (this.domain === '2mtraining.pika-aero.com') {
				return "2MTraining";
			} else {
				return "Pika Aero";
			}
		}
	},

	methods: {
		handleDateInput(event) {
			let input = event.target.value;

			// Enlever tous les caractères non numériques
			input = input.replace(/\D/g, '');

			// Formatage automatique en DD/MM/YYYY
			if (input.length <= 2) {
				this.form.birthDate = input;
			} else if (input.length <= 4) {
				this.form.birthDate = `${input.slice(0, 2)}/${input.slice(2)}`;
			} else {
				this.form.birthDate = `${input.slice(0, 2)}/${input.slice(2, 4)}/${input.slice(4, 8)}`;
			}
		},

		logoSize() {
			if (this.domain === '2mtraining.pika-aero.com') {
				return { width: "80px" };
			} else {
				return { width: "160px" };
			}
		},

		clearError(field) {
			// Supprime l'erreur pour le champ spécifié
			if (this.errors[field]) {
				delete this.errors[field];
			}
		},

		validateForm() {
			this.errors = {};

			if (!this.form.firstName) {
				this.errors.firstName = "Le prénom est obligatoire.";
			}

			if (!this.form.lastName) {
				this.errors.lastName = "Le nom est obligatoire.";
			}

			if (!this.form.birthDate) {
				this.errors.birthDate = "Veuillez entrer une date de naissance valide.";
			}

			if (!this.form.birthDate || !this.isValidDate(this.form.birthDate)) {
				this.errors.birthDate = "Veuillez entrer une date de naissance valide (JJ/MM/AAAA).";
			}

			if (!this.form.email || !this.validateEmail(this.form.email)) {
				this.errors.email = "Veuillez entrer une adresse e-mail valide.";
			}

			if (!this.form.password || this.form.password.length < 6) {
				this.errors.password = "Le mot de passe doit contenir au moins 6 caractères.";
			}

			if (!this.form.terms) {
				this.errors.terms = "Vous devez accepter les conditions générales.";
			}

			if (!this.form.companyName) {
				this.errors.companyName = "Le nom de votre société est obligatoire";
			}

			return Object.keys(this.errors).length === 0;
		},

		validateEmail(email) {
			const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
			return re.test(email);
		},

		isValidDate(str) {
			if (!/^\d{2}\/\d{2}\/\d{4}$/.test(str))
				return false;

			const [dd, mm, yyyy] = str.split('/').map(Number);
			// construire une date ISO "YYYY-MM-DD"
			const date = new Date(`${yyyy}-${mm.toString().padStart(2,'0')}-${dd.toString().padStart(2,'0')}`);
			// vérifier que la date existe vraiment
			return (
				date.getFullYear() === yyyy &&
				date.getMonth() + 1   === mm &&
				date.getDate()        === dd
			);
		},

		async registerUser() {
			const validated = this.validateForm();

			if (!validated)
				return;

			let data = this.form;
			delete data.terms;

			try {
				const response = await HTTP.post('/auth/registration', data);

				// Save JWT
				this.$store.dispatch("saveJwt", response.data.accessToken);

				event("register", {
					'send_to': 'AW-16956522772/v7O2CLfs47IaEJSCwJU_'
				});

				// Setup company
				this.$router.push("/setup-company");
			} catch (error) {
				// Récupérer le message d'erreur de l'API ou définir un message par défaut
				const errorMessage = error?.response?.data?.message || "Une erreur est survenue, merci de contacter contact@pika-aero.com";

				alert(errorMessage);

				// Log détaillé dans la console (utile en développement)
				console.error("Erreur API:", error);
			}
		}
	}
};
</script>
